import { z } from 'zod';

export const UserInfoSchema = z.object({
  email: z.string().nonempty().email(),
  group: z.string().nonempty(),
  customer: z.string().nonempty(),
});

export type UserInfo = z.infer<typeof UserInfoSchema>;
